const API_BASE_URL = 'https://apisaleeasy.psisat.com/api';

export const arService = {
  async getBillSummary(dateFrom, dateTo) {
    try {
      const params = new URLSearchParams();
      if (dateFrom) params.append('dateFrom', dateFrom);
      if (dateTo) params.append('dateTo', dateTo);
      const qs = params.toString() ? `?${params}` : '';
      const response = await fetch(`${API_BASE_URL}/ar-bill-tran/summary${qs}`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error('arService.getBillSummary error:', error);
      return { success: false, error: error.message };
    }
  },

  async searchBills(paymentStatus, limit = 50) {
    try {
      const params = new URLSearchParams();
      if (paymentStatus) params.append('payment_status', paymentStatus);
      if (limit) params.append('limit', limit);
      const response = await fetch(`${API_BASE_URL}/ar-bill-tran/search?${params}`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error('arService.searchBills error:', error);
      return { success: false, error: error.message };
    }
  },

  async getCustomerBills(custNo) {
    try {
      const response = await fetch(`${API_BASE_URL}/ar-bill-tran/customer/${custNo}`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error('arService.getCustomerBills error:', error);
      return { success: false, error: error.message };
    }
  },

  async getOverdueStats() {
    try {
      const response = await fetch(`${API_BASE_URL}/overdue-invoices/stats`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error('arService.getOverdueStats error:', error);
      return { success: false, error: error.message };
    }
  },

  async getCollectionStatusSummary() {
    try {
      const response = await fetch(`${API_BASE_URL}/overdue-invoices/status-summary`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error('arService.getCollectionStatusSummary error:', error);
      return { success: false, error: error.message };
    }
  },

  async getOverdueList(params = {}) {
    try {
      const query = new URLSearchParams(params);
      const response = await fetch(`${API_BASE_URL}/overdue-invoices/list?${query}`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error('arService.getOverdueList error:', error);
      return { success: false, error: error.message };
    }
  },

  async getCreditDashboard() {
    try {
      const response = await fetch(`${API_BASE_URL}/customer-credit/dashboard`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error('arService.getCreditDashboard error:', error);
      return { success: false, error: error.message };
    }
  },

  async getCustomersByRiskLevel(riskLevel) {
    try {
      const response = await fetch(`${API_BASE_URL}/customer-credit/risk/${riskLevel}`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error('arService.getCustomersByRiskLevel error:', error);
      return { success: false, error: error.message };
    }
  },

  async getCustomersOverdue(minDays) {
    try {
      const params = minDays ? `?minDays=${minDays}` : '';
      const response = await fetch(`${API_BASE_URL}/customer-credit/overdue${params}`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error('arService.getCustomersOverdue error:', error);
      return { success: false, error: error.message };
    }
  },

  async getProblematicCustomers(riskLevel) {
    try {
      const params = riskLevel ? `?riskLevel=${riskLevel}` : '';
      const response = await fetch(`${API_BASE_URL}/credit-bill-verification/problematic-customers${params}`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error('arService.getProblematicCustomers error:', error);
      return { success: false, error: error.message };
    }
  }
};
